import { createFileRoute, useParams } from '@tanstack/react-router';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import DataIndexItemPage from '@/pages/workspaces/data-index/item/index.page';
import { DataIndexRoute } from '@/pages/workspaces/data-index/routing';
import { DataIndexItemResolver } from '@/pages/workspaces/data-index/data-index-item-resolver';
import { LastWorkspaceResolver } from './-route-layouts';

/** One person attribute or event: `/data-index/attributes/plan`. */
function DataIndexItemRouteComponent() {
  const { type, itemId } = useParams({ from: '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/' });

  return (
    <LastWorkspaceResolver>
      <DataIndexItemResolver segment={type} itemId={itemId}>
        {(address) => (
          <DataIndexRoute>
            <RumPageRendered>
              <DataIndexItemPage address={address} />
            </RumPageRendered>
          </DataIndexRoute>
        )}
      </DataIndexItemResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/')({
  component: DataIndexItemRouteComponent,
});
